<script setup>

import { inject } from 'vue';
import ListeConstantes from './listeConstantes/ListeConstantes.vue';
import DetailConstante from './detailConstante/DetailConstante.vue';

const { constantes } = defineProps({
  constantes: Array
});

const selectionSchema = inject('selectionSchema');

</script>

<template>
	<div class="panel-lateral contenu-onglet-schema">
		<ListeConstantes :constantes="constantes" />
		<DetailConstante v-if="selectionSchema.constante" :constante="selectionSchema.constante" />
	</div>
</template>

<style scoped>
</style>